import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueI18n from 'vue-i18n'
import { data } from '@/lang/index.ts'
import 'babel-polyfill'
import VueAnalytics from 'vue-analytics'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// アイコンを読み込み
library.add(fas, far, fab)
// Vueコンポーネントを作成
Vue.component('v-fa', FontAwesomeIcon)

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-172938743-1',
  router
})
const DEFAULT_TITLE = 'Suzuka Hisamatsu - between us -'
router.afterEach((to, from) => {
  document.title = DEFAULT_TITLE
})
// Vue.config.devtools = true
Vue.config.productionTip = false
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: navigator.language.split('-')[0], // デフォルト言語設定
  fallbackLocale: 'en', // 選択中の言語に対応する文字列が存在しない場合はこの言語の文字列を使用する
  messages: data

})
new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
